enum RelationStatus {
  CURRENT = 'current',
  FORMER = 'former',
  DECEASED = 'deceased',
}

export default RelationStatus;
